import { Pipe, PipeTransform } from '@angular/core';
import { BmsDataExportValue } from '../../models/bms-data-export-value';

@Pipe({
  name: 'bmsdataexportexternalidpipe'
})
export class BmsDataExportValueExternalId implements PipeTransform {

  transform(exportValue : BmsDataExportValue): string {
    let result = exportValue.externalId;
    if (exportValue.calculatedMeterId > 0) {
      result += ' (SUB)';
    }
    else if (exportValue.nodeTypeId == '_x_bms_calculatedmeter') {
      result += ' (CALC)';
    }

    return result;
  }

}
